// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| THISCREET LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Speech bubble with Thiscreet logo icon */}
      <g transform="translate(2.5, 2.5)">
        {/* Speech bubble background */}
        <path 
          d="M5 5C5 2.791 6.791 1 9 1H21C23.209 1 25 2.791 25 5V17C25 19.209 23.209 21 21 21H13L9 25V21H9C6.791 21 5 19.209 5 17V5Z" 
          fill="#4A90E2"
        />
        
        {/* Infinity-style logo based on the provided image */}
        <g transform="translate(15, 13)">
          {/* Infinity symbol made of two overlapping circles */}
          <path 
            d="M-4 0C-4 -2.5 -1.5 -4 1 -4C3.5 -4 6 -2.5 6 0C6 2.5 3.5 4 1 4C-1.5 4 -4 2.5 -4 0Z" 
            fill="none" 
            stroke="white" 
            strokeWidth="1.5"
          />
          <path 
            d="M-6 0C-6 -2.5 -3.5 -4 -1 -4C1.5 -4 4 -2.5 4 0C4 2.5 1.5 4 -1 4C-3.5 4 -6 2.5 -6 0Z" 
            fill="none" 
            stroke="white" 
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
}
